module.exports = __webpack_public_path__ + "img/teaching-6.4d868d73.png";